import { FieldOccurences } from "../../types/FieldOccurences/FieldOccurences";
import { PaginationValues } from "../../types/General/PaginationValues";
import api from "../../utils/api";
import { OCCURENCE_URL } from "../../utils/endpoints";

export async function getFieldOccurences(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      id ? `${OCCURENCE_URL}/${id}` : `${OCCURENCE_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );
    const data: FieldOccurences[] = id
      ? response.data.name
      : response.data.result.map((option: FieldOccurences) => ({
          id: option.id,
          title: option.title,
          type: option.type,
          level: option.level,
          origin: option.origin,
          createdAt: option.createdAt,
          finishedAt: option.finishedAt ?? null,
          isActive: option.isActive,
          province: option.province ?? null,
          county: option.county ?? null,
          description: option.description,
          indicator: option.indicator ?? null,
          userName: option.userName,
        }));
    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
